import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage.tsx';
import AnalyticsStatDetailPage from './pages/AnalyticsStatDetailPage.tsx';
import DashboardPage from './pages/DashboardPage.tsx';
import ClientsPage from './pages/ClientsPage.tsx';
import ClientDetailsPage from './pages/ClientDetailsPage.tsx';
import NewPage from './pages/NewPage.tsx';
import ProfilePage from './pages/ProfilePage.tsx';
import SettingsAdvancedPage from './pages/SettingsAdvancedPage.tsx';
import TodayPage from './pages/TodayPage.tsx';
import SettingsPage from './pages/SettingsPage.tsx';
import TasksPage from './pages/TasksPage.tsx';
import LeadFormRoute from './routes/LeadFormRoute.tsx';
import InviteClientRoute from './routes/InviteClientRoute.tsx';
import BookingFormRoute from './routes/BookingFormRoute.tsx';
import MeasurementFormRoute from './routes/MeasurementFormRoute.tsx';
import TrainingPlanFormRoute from './routes/TrainingPlanFormRoute.tsx';
import VideosRoute from './routes/VideosRoute.tsx';
import TaskFormRoute from './routes/TaskFormRoute.tsx';
import { AppUpdateBanner } from './components/AppUpdateBanner';

function App() {
  return (
    <BrowserRouter>
      <AppUpdateBanner />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<Layout />}>
          <Route path="/" element={<TodayPage />} />
          <Route path="/bookings/new" element={<BookingFormRoute />} />
          <Route path="/bookings/:bookingId/edit" element={<BookingFormRoute />} />
          <Route path="/leads" element={<Navigate to="/clients?filter=leads" replace />} />
          <Route path="/leads/new" element={<LeadFormRoute />} />
          <Route path="/leads/:leadId/edit" element={<LeadFormRoute />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/invite" element={<InviteClientRoute />} />
          <Route path="/clients/:id" element={<ClientDetailsPage />} />
          <Route path="/clients/:id/measurements/new" element={<MeasurementFormRoute />} />
          <Route path="/clients/:id/measurements/:measurementId/edit" element={<MeasurementFormRoute />} />
          <Route path="/clients/:id/plans/new" element={<TrainingPlanFormRoute />} />
          <Route path="/clients/:id/plans/:planId/edit" element={<TrainingPlanFormRoute />} />
          <Route path="/schedule" element={<Navigate to="/" replace />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/tasks/new" element={<TaskFormRoute />} />
          <Route path="/tasks/:taskId/edit" element={<TaskFormRoute />} />
          <Route path="/analytics" element={<DashboardPage />} />
          <Route path="/analytics/:statId" element={<AnalyticsStatDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/videos" element={<VideosRoute />} />
          <Route path="/settings/advanced" element={<SettingsAdvancedPage />} />
          <Route path="/new" element={<NewPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/menu" element={<Navigate to="/profile" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
